import { ModalCustom } from "components/ModalCustom";
import { FaExclamationTriangle } from "react-icons/fa";
import { BodyPergunta, BodyTexto, ModalBodyContainer } from "./style";

interface IProps {
  showModalExportar: boolean;
  handleCloseModalExportar: () => void;
  onConfirmModalExportar: () => void;
}
export function ModalAvisoExportar({
  showModalExportar,
  handleCloseModalExportar,
  onConfirmModalExportar,
}: IProps) {
  return (
    <ModalCustom
      show={showModalExportar}
      handleClose={handleCloseModalExportar}
      title="Exportar CRLV"
      onConfirm={onConfirmModalExportar}
      centered
      footer
      footerConfirmButton
    >
      <ModalBodyContainer>
        <BodyTexto>
          A seleção do checkbox contempla apenas os veículos listados na página
          atual, para exportar todos os CRLVs disponíveis no lote, clique no
          botão <strong>Exportar CRLV</strong> sem selecionar nenhum checkbox.
        </BodyTexto>
        <BodyPergunta>
          <FaExclamationTriangle></FaExclamationTriangle>
          Deseja exportar os CRLVs selecionados?
        </BodyPergunta>
      </ModalBodyContainer>
    </ModalCustom>
  );
}
